export enum Theme {
    DAY = 'day-theme',
    NIGHT = 'night-theme',
    GREEN = 'green-theme',
  }